export const RESET_NFSE = 'NFSE/RESET_NFSE';
export const SET_SUMMARY_NFSES = 'NFSE/SET_SUMMARY_NFSES';
export const SET_PAGINATION_NFSE = 'NFSE/SET_PAGINATION_NFSE';
export const SET_DETAILED_NFSE = 'NFSE/SET_DETAILED_NFSE';
export const SET_NFSE_WARNINGS = 'NFSE/SET_NFSE_WARNINGS';
export const SET_SERVICE_IN_COLLECTION = 'NFSE/SET_SERVICE_IN_COLLECTION';
export const UPDATE_SERVICE_IN_COLLECTION = 'NFSE/UPDATE_SERVICE_IN_COLLECTION';
export const SET_INSTALLMENTS_RANGE = 'NFSE/SET_INSTALLMENTS_RANGE';
export const SET_REMAINDER = 'NFSE/SET_REMAINDER';
export const SET_CALCULATED_NFSE = 'NFSE/SET_CALCULATED_NFSE';
export const SET_TAXES_CONFIGURATIONS = 'NFSE/SET_TAXES_CONFIGURATIONS';
export const SET_EMISSION_CONFIGURATIONS = 'NFSE/SET_EMISSION_CONFIGURATIONS';
export const SET_NATURE_OF_OPERATION = 'NFSE/SET_NATURE_OF_OPERATION';
export const SET_FISCAL_VALIDATION = 'NFSE/SET_FISCAL_VALIDATION';
